import script from "./RicetteTable2.vue?vue&type=script&setup=true&lang=js"
export * from "./RicetteTable2.vue?vue&type=script&setup=true&lang=js"

import "./RicetteTable2.vue?vue&type=style&index=0&id=e1dd1d3c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e1dd1d3c"]])

export default __exports__